const filters = [
  { id: 'all', label: 'All', count: 5 },
  { id: 'suppliers', label: 'Suppliers', count: 2 },
  { id: 'employees', label: 'Employees', count: 1 },
  { id: 'citizens', label: 'Citizens & beneficiaries', count: 2 }
];

const cards = [
  { label: 'Open complaints', value: '4', note: 'In workflow', accent: 'dark' },
  { label: 'Within SLA', value: '5', note: 'On time', accent: 'green' },
  { label: 'Escalated', value: '1', note: 'Need decision', accent: 'red' },
  { label: 'Resolved', value: '1', note: 'Closed with outcome', accent: 'green' }
];

const rows = [
  { ref: 'CG-01', complaint: 'Supplier complaint - unfair tender treatment', category: 'Unfair tender treatment', complainant: 'Supplier', department: 'Procurement', sla: 'Day 6 / 10', status: { label: 'Investigation', class: 'bg-warning-subtle text-warning-emphasis' }, filter_id: 'suppliers' },
  { ref: 'CG-02', complaint: 'Employee grievance - workload & overtime', category: 'Workplace grievance', complainant: 'Employee', department: 'HR', sla: 'Day 3 / 7', status: { label: 'In progress', class: 'bg-warning-subtle text-warning-emphasis' }, filter_id: 'employees' },
  { ref: 'CG-03', complaint: 'Beneficiary complaint - programme access', category: 'Service delivery', complainant: 'Beneficiary', department: 'Programme', sla: 'Day 9 / 14', status: { label: 'Escalated', class: 'bg-danger-subtle text-danger-emphasis' }, filter_id: 'citizens' },
  { ref: 'CG-04', complaint: 'Customer complaint - billing error', category: 'Service quality', complainant: 'Customer', department: 'Finance', sla: 'Resolved - day 4', status: { label: 'Resolved', class: 'bg-success-subtle text-success-emphasis' }, filter_id: 'citizens' },
  { ref: 'CG-05', complaint: 'Supplier complaint - delayed payment', category: 'Late payment', complainant: 'Supplier', department: 'Finance', sla: 'Day 2 / 7', status: { label: 'In progress', class: 'bg-warning-subtle text-warning-emphasis' }, filter_id: 'suppliers' }
];

const complaint_drawer_catalog = {
  'CG-01': {
    kicker: 'Complaint',
    subtitle: 'Procurement fairness complaint',
    badge: { label: 'Investigation', class: 'bg-warning-subtle text-warning-emphasis' },
    details: [
      { label: 'Complaint', value: 'Supplier alleges unfair treatment in a tender' },
      { label: 'Category', value: 'Unfair tender treatment' },
      { label: 'Complainant type', value: 'Supplier (bidder)' },
      { label: 'Responsible department', value: 'Procurement / SCM' },
      { label: 'SLA', value: '10 working days - day 6' },
      { label: 'Investigation notes', value: 'Reviewing evaluation scoring & declarations' },
      { label: 'Resolution actions', value: 'Pending findings' },
      { label: 'Escalation', value: 'To SCM Manager if substantiated' },
      { label: 'Closure evidence', value: 'Decision & response letter' },
      { label: 'Outcome', value: 'Open' },
      { label: 'Status', value: 'Investigation' }
    ],
    checks: {
      title: 'Evidence & checks',
      badge: '2 need action',
      items: [
        { title: 'Evaluation records', subtitle: 'Retrieved for review', state: 'good', state_label: 'On file' },
        { title: 'Conflict declarations', subtitle: 'Re-checking bid committee', state: 'checking', state_label: 'Checking' },
        { title: 'Response letter', subtitle: 'Due within SLA', state: 'due', state_label: 'Due' }
      ]
    },
    records: [
      { type: 'Procurement', title: 'Tender / evaluation' },
      { type: 'Conflicts', title: 'Bid declarations' },
      { type: 'Supplier', title: 'Complainant' },
      { type: 'Legal matters', title: 'If escalated' },
      { type: 'Evidence', title: 'Decision evidence' },
      { type: 'Reports', title: 'Response record' }
    ],
    recommendation: 'A supplier complains about unfair tender treatment. The complaint links the procurement event, evaluation records, conflict declarations, decision evidence and the response record. Resolve within SLA - an unanswered fairness complaint can become a legal matter.',
    footer: { left_label: 'Watch', secondary_label: 'Evidence', primary_label: 'Open investigation' }
  },
  'CG-02': {
    kicker: 'Complaint',
    subtitle: 'Formal grievance',
    badge: { label: 'In progress', class: 'bg-warning-subtle text-warning-emphasis' },
    details: [
      { label: 'Complaint', value: 'Grievance over workload and unpaid overtime' },
      { label: 'Category', value: 'Workplace grievance' },
      { label: 'Complainant type', value: 'Employee' },
      { label: 'Responsible department', value: 'HR' },
      { label: 'SLA', value: '7 working days - day 3' },
      { label: 'Investigation notes', value: 'Manager statement obtained' },
      { label: 'Resolution actions', value: 'Workload review scheduled' },
      { label: 'Outcome', value: 'In progress' },
      { label: 'Status', value: 'In progress' }
    ],
    checks: null,
    records: [
      { type: 'Employees', title: 'Staff register' },
      { type: 'Incident', title: 'Linked HR case' },
      { type: 'Risk', title: 'Labour risk' },
      { type: 'Evidence', title: 'Grievance file' }
    ],
    recommendation: 'Within SLA. Complete the workload review and document the outcome - unresolved grievances can escalate to a CCMA referral (see legal matters).',
    footer: { left_label: 'Watch', secondary_label: 'Evidence', primary_label: 'Open grievance' }
  },
  'CG-03': {
    kicker: 'Complaint',
    subtitle: 'Funded programme complaint',
    badge: { label: 'Escalated', class: 'bg-danger-subtle text-danger-emphasis' },
    details: [
      { label: 'Complaint', value: 'Beneficiary cannot access funded service' },
      { label: 'Category', value: 'Service delivery' },
      { label: 'Complainant type', value: 'Beneficiary' },
      { label: 'Responsible department', value: 'Programme team' },
      { label: 'SLA', value: '14 days - day 9' },
      { label: 'Investigation notes', value: 'Provider capacity shortfall identified' },
      { label: 'Resolution actions', value: 'Provider remediation requested' },
      { label: 'Escalation', value: 'Escalated to Programme Manager' },
      { label: 'Outcome', value: 'Pending' },
      { label: 'Status', value: 'Escalated' }
    ],
    checks: null,
    records: [
      { type: 'Service delivery', title: 'Delivery (SD-01)' },
      { type: 'Grant', title: 'Funded programme' },
      { type: 'Supplier', title: 'Delivery partner' },
      { type: 'Evidence', title: 'Complaint record' },
      { type: 'Reports', title: 'Funder report' }
    ],
    recommendation: 'This complaint signals a delivery shortfall on a funded programme. Drive provider remediation and note it against service delivery - funders treat beneficiary complaints as a red flag.',
    footer: { left_label: 'Watch', secondary_label: 'Evidence', primary_label: 'Escalate complaint' }
  },
  'CG-04': {
    kicker: 'Complaint',
    subtitle: 'Billing dispute',
    badge: { label: 'Resolved', class: 'bg-success-subtle text-success-emphasis' },
    details: [
      { label: 'Complaint', value: 'Customer billed incorrectly' },
      { label: 'Category', value: 'Service quality / billing' },
      { label: 'Complainant type', value: 'Customer' },
      { label: 'Responsible department', value: 'Finance' },
      { label: 'SLA', value: 'Resolved in 4 days' },
      { label: 'Resolution actions', value: 'Credit note issued, apology sent' },
      { label: 'Closure evidence', value: 'Credit note + correspondence' },
      { label: 'Outcome / satisfaction', value: 'Satisfied' },
      { label: 'Status', value: 'Resolved' }
    ],
    checks: null,
    records: [
      { type: 'Finance', title: 'Credit note' },
      { type: 'Evidence', title: 'Resolution record' }
    ],
    recommendation: 'Resolved within SLA with a satisfied outcome. Keep the credit note and correspondence on file as closure evidence for trend analysis.',
    footer: { left_label: 'Watch', secondary_label: 'Evidence', primary_label: 'View resolution' }
  },
  'CG-05': {
    kicker: 'Complaint',
    subtitle: 'Payment grievance',
    badge: { label: 'In progress', class: 'bg-warning-subtle text-warning-emphasis' },
    details: [
      { label: 'Complaint', value: 'Supplier reports a delayed payment' },
      { label: 'Category', value: 'Late payment' },
      { label: 'Complainant type', value: 'Supplier' },
      { label: 'Responsible department', value: 'Finance' },
      { label: 'SLA', value: '7 days - day 2' },
      { label: 'Investigation notes', value: 'Invoice on hold pending evidence (3-way match)' },
      { label: 'Resolution actions', value: 'Confirm GRN, then release' },
      { label: 'Outcome', value: 'In progress' },
      { label: 'Status', value: 'In progress' }
    ],
    checks: null,
    records: [
      { type: 'Finance', title: 'Invoice / payment' },
      { type: 'Supplier', title: 'Complainant' },
      { type: 'Procurement', title: 'PO / GRN' },
      { type: 'Evidence', title: 'Payment record' }
    ],
    recommendation: 'The delay is a control working - the invoice is held pending a goods-received note. Communicate the reason to the supplier and release on valid evidence to close within SLA.',
    footer: { left_label: 'Watch', secondary_label: 'Evidence', primary_label: 'Open complaint' }
  }
};

export default {
  name: 'ComplyonComplaintsGrievances',
  data: () => ({
    filters,
    active_filter: 'all',
    search_query: '',
    active_complaint_ref: null,
    cards,
    rows
  }),
  computed: {
    filtered_rows() {
      const search = this.search_query.trim().toLowerCase();

      return this.rows.filter((row) => {
        const matches_filter = this.active_filter === 'all' || row.filter_id === this.active_filter;
        if (!matches_filter) return false;
        if (!search) return true;

        const haystack = [row.ref, row.complaint, row.category, row.complainant, row.department, row.sla, row.status.label]
          .join(' ')
          .toLowerCase();

        return haystack.includes(search);
      });
    },
    active_complaint() {
      return this.rows.find((row) => row.ref === this.active_complaint_ref) || null;
    },
    active_complaint_drawer() {
      return this.active_complaint_ref ? complaint_drawer_catalog[this.active_complaint_ref] || null : null;
    }
  },
  methods: {
    set_filter(filter_id) {
      this.active_filter = filter_id;
    },
    open_complaint_drawer(row) {
      if (!row?.ref) return;
      this.active_complaint_ref = row.ref;
    },
    close_complaint_drawer() {
      this.active_complaint_ref = null;
    },
    complaint_record_icon(type) {
      const icon_map = {
        Procurement: 'bi-briefcase',
        Conflicts: 'bi-shield-exclamation',
        Supplier: 'bi-building',
        'Legal matters': 'bi-balance-scale',
        Evidence: 'bi-folder2-open',
        Reports: 'bi-file-earmark-bar-graph',
        Employees: 'bi-person',
        Incident: 'bi-exclamation-diamond',
        Risk: 'bi-shield-exclamation',
        'Service delivery': 'bi-activity',
        Grant: 'bi-bank',
        Finance: 'bi-receipt'
      };

      return Reflect.get(icon_map, type) || 'bi-link-45deg';
    },
    complaint_check_icon(state) {
      const icon_map = {
        good: 'bi-check-circle',
        checking: 'bi-arrow-repeat',
        due: 'bi-exclamation-circle'
      };

      return Reflect.get(icon_map, state) || 'bi-dot';
    },
    complaint_check_state_class(state) {
      const class_map = {
        good: 'is-green',
        checking: 'is-orange',
        due: 'is-orange'
      };

      return Reflect.get(class_map, state) || 'is-slate';
    },
    complaint_check_badge_class(state) {
      const class_map = {
        good: 'bg-success-subtle text-success-emphasis',
        checking: 'bg-warning-subtle text-warning-emphasis',
        due: 'bg-warning-subtle text-warning-emphasis'
      };

      return Reflect.get(class_map, state) || 'bg-light text-secondary border border-light';
    }
  }
};
